export const types = {
  REMOVE_ITEM_FROM_CART: 'REMOVE_ITEM_FROM_CART',
  COPY: 'COPY',
  REMOVE_DELIVERY: 'REMOVE_DELIVERY',
  ADD_DELIVERY_ADDRESS: 'ADD_DELIVERY_ADDRESS',
  ADD_DELIVERY_CONTECT_PERSON: 'ADD_DELIVERY_CONTECT_PERSON',
  ADD_DELIVERY_TOKEN: 'ADD_DELIVERY_TOKEN',
  ADD_DELIVERY_FILE: 'ADD_DELIVERY_FILE',
  BIND_BACKEND_DELIVERIES: 'BIND_BACKEND_DELIVERIES',
  RESET_CONFECTION_CHOICE: 'RESET_CONFECTION_CHOICE',
  RESET_DELIVERY_FILE: 'RESET_DELIVERY_FILE',
  SET_FILE_DELIVERIES_STATE: 'SET_FILE_DELIVERIES_STATE',
  HYDRATE: 'HYDRATE',
};
